import { API_BASE_URL } from "./config";

async function registerFcmToken(token: string, siteId?: number | null): Promise<void> {
  const res = await fetch(`${API_BASE_URL}/push/subscriptions`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ token, siteId: siteId ?? undefined, deviceLabel: navigator.userAgent }),
  });
  if (!res.ok) throw new Error(`FCM 토큰 등록 실패 (${res.status})`);
}

export const pushService = {
  registerFcmToken,
};
